// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1fCmq","checkboxCol":"Table_checkboxCol__NPrq4","emailCol":"Table_emailCol__1zNgn","actionCol":"Table_actionCol__2tQAK"};